import React, { useEffect, useContext, useState } from 'react';
import Stories from '../components/Stories';
import { deepEqual, getDataWithFetch, setLocalStorage } from '../components/Utils';
import ApplicationContext from '../components/ApplicationContext';

const TopStories = ({ setData }) => {
    const data = useContext(ApplicationContext);
	const [, setTopStoriesResults] = useState();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		// console.log('DEBUG', `TopStories - data.BASE_URL = `, data.BASE_URL);
		// console.log('DEBUG', `TopStories - data.TopStoriesResults = `, data.TopStoriesResults);

		(async() => {
			if (data.BASE_URL) {
				// console.log('DEBUG:  BASE_URL - ', data.BASE_URL);
				const url = data.BASE_URL + "index.php/news_data/get_top_stories";
				// console.log('DEBUG:  url - ', url);
				const res = await getDataWithFetch(url);
				setTopStoriesResults(res);
				// console.log('DEBUG', `Stories - get_top_stories number of records ${res ? res.length : 0}`);
				if (!deepEqual(data.TopStoriesResults, res)) {
					data.TopStoriesResults = res;
				}
			}
		})()
	}, [data, data.BASE_URL, data.TopStoriesResults]);

	return (
        <>
            <div className="all-links-container">
                <h3 className="all-links">
                    <button className="link-button" onClick={(e) => {
						e.preventDefault();
                        setLocalStorage('currentPage', 'home');
                        data.currentPage = 'home';
						setData((prev) => ({ ...prev, currentPage: 'home' }))
				    }}>Back to Main</button>
                </h3>
            </div>
            <h3 className="top-stories-header">Top Stories</h3>
            <Stories enableAdmin={false} topStories={true} />
        </>
	);
};

export default TopStories;
